const AMWELL = 'Amwell'

export default { AMWELL }
